import { css } from '@emotion/react'
import { Spacing, Typography } from '@opallabs/gem'
import {
  buttonSelectors,
  iconSelectors,
  screenreaderOnly,
  singleSelectSelectors,
  textInputSelectors,
} from '@opallabs/lapidary'

export const rootClass = 'admin-customfield-pairingform'
export const classes = {
  columnTitle: `${rootClass}-column-title`,
  header: `${rootClass}-header`,
  row: `${rootClass}-table-row`,
  tableRoot: `${rootClass}-table-root`,
  textInput: `${rootClass}-text-input`,
  titleRow: `${rootClass}-title-row`,
} as const

export const form = css({
  paddingInline: 2,
  paddingBlockEnd: 2,

  [`.${classes.tableRoot} + .${classes.tableRoot}`]: {
    marginBlockStart: Spacing.L,
  },
})

const iconMarginInline = Spacing.M
export const iconSize = Spacing.XS * 5
export const row = css({
  // @note The `textInput` selector ensures `<TextInput>`'s error state goes below the input, which expands its height,
  // so the typical `align-items: center` doesn't work here -- that makes the icon and dropdown shift when the error
  // state is visible.
  alignItems: 'start',
  border: 'none',
  display: 'flex',
  margin: 0,
  padding: 0,
  justifyContent: 'space-between',

  [`.${classes.textInput}, .${singleSelectSelectors.root}`]: {
    flexGrow: 1,
    inlineSize: `calc((100% - ${iconSize}px - calc(${iconMarginInline}px * 2)) / 2)`,
  },
  [`.${classes.textInput} .${textInputSelectors.container}`]: {
    blockSize: Spacing.XS * 9,
  },
  [`.${textInputSelectors.errorMessage}`]: screenreaderOnly,
  [`> .${iconSelectors.root}`]: {
    alignItems: 'center',
    // `<Icon>` applies `block-size` and `inline-size` as inline styles on the container, so unfortunately `!important`
    // is required here to override it and make the row's `align-items: start` work correctly while keeping the icon
    // visually centered with the inputs.
    blockSize: `${Spacing.M * 2}px !important`,
    marginInline: iconMarginInline,
  },
})

export const tableRoot = css({
  [`.${classes.header}`]: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  [`.${classes.columnTitle}`]: {
    display: 'flex',
    flexGrow: 1,
    inlineSize: `calc((100% - ${iconSize}px - calc(${iconMarginInline}px * 2)) / 2)`,
    marginBlockEnd: Spacing.M,
    ...Typography.H50,
  },
  [`&.${classes.titleRow} .${classes.columnTitle}`]: {
    marginBlockEnd: Spacing.S,
  },
  [`&.${classes.titleRow} .${textInputSelectors.errorMessage}`]: {
    // red error state text just below the input, likely name validation issues
    clip: 'rect(0, 0, 0, 0)',
    clipPath: 'none',
    blockSize: 'auto',
    overflow: 'visible',
    position: 'static',
    whiteSpace: 'normal',
    inlineSize: 'auto',
  },
  [`.${classes.columnTitle} + .${classes.columnTitle}`]: {
    marginInlineStart: `calc(${iconSize}px + calc(${iconMarginInline}px * 2))`,
  },
  [`.${classes.row} + .${classes.row}`]: {
    marginBlockStart: Spacing.XS * 3,
  },
  [`.${buttonSelectors.root}`]: {
    marginBlockStart: Spacing.XS * 3,
  },
})
